import React from 'react';
import { PromotionItem, typeColors, statusColors } from '../promotionsTypes';
import { RowActionsMenu } from '../../../../components/RowActionsMenu';
import styles from './PromotionsTable.module.css';

interface PromotionsTableProps {
  items: PromotionItem[];
  onToggleActive?: (id: string, currentStatus: PromotionItem['status']) => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
  busyId?: string | null;
}

export const PromotionsTable: React.FC<PromotionsTableProps> = ({ items, onToggleActive, onEdit, onDelete, busyId }) => {
  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>PROMOTION</th>
            <th>TYPE</th>
            <th>CONDITIONS</th>
            <th>TIER</th>
            <th>DATE RANGE</th>
            <th>USED</th>
            <th>STATUS</th>
            <th>ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id}>
              <td className={styles.nameCell}>{item.name}</td>
              <td>
                <span className={styles.typeBadge}>
                  <span className={styles.typeDot} style={{ background: typeColors[item.type] }} />
                  {item.type}
                </span>
              </td>
              <td className={styles.conditionsCell}>{item.conditions}</td>
              <td className={styles.tierCell}>{item.tier}</td>
              <td className={styles.dateCell}>{item.dateRange}</td>
              <td className={styles.usedCell}>{item.used}</td>
              <td>
                <span className={styles.statusBadge} style={{ color: statusColors[item.status] }}>
                  <span className={styles.statusDot} style={{ background: statusColors[item.status] }} />
                  {item.status}
                </span>
              </td>
              <td>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  <button
                    type="button"
                    className={styles.editBtn}
                    disabled={busyId === item.id || item.status === 'Expired'}
                    onClick={() => onToggleActive?.(item.id, item.status)}
                  >
                    {busyId === item.id ? '…' : item.status === 'Active' ? 'Pause' : 'Activate'}
                  </button>
                  {(onEdit || onDelete) && (
                    <RowActionsMenu
                      onEdit={onEdit ? () => onEdit(item.id) : undefined}
                      onDelete={onDelete ? () => onDelete(item.id) : undefined}
                    />
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
